import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

// const ENDPOINT_URL ='https://insite-api2.dev.healthmarkets.com/ConsumerApi/LisInfo';
const ENDPOINT_URL = process.env.VUE_APP_API_HOST || '//hm-lis.herokuapp.com';

export default new Vuex.Store({
  state: {
    size: 'small',
    step: 'start',
    isBusy: false,
    queryString: false,
    data: {
      hasMedicaid: false,
      extraHelp: {
        howMuch: 0,
        amount: 0,
      },
      moreThan14390: false,
      houseHoldIncome: {
        monthlyChecks: 0,
        workingIncome: 0,
      },
      howManyPeople: 0,
    },
    score: 0,
  },
  mutations: {
    setBusy(state, isBusy) {
      state.isBusy = isBusy;
    },
    setQueryString(state, queryString) {
      state.queryString = queryString;
    },
    setStep(state, step) {
      state.step = step;
    },
    setHasMedicaid(state, hasMedicaid) {
      state.data.hasMedicaid = hasMedicaid;
    },
    setExtraHelp(state, extraHelp) {
      state.data.extraHelp = extraHelp;
    },
    setMoreThan14390(state, moreThan14390) {
      state.data.moreThan14390 = moreThan14390;
    },
    setMonthlyChecks(state, monthlyChecks) {
      state.data.houseHoldIncome.monthlyChecks = monthlyChecks;
    },
    setWorkingIncome(state, workingIncome) {
      state.data.houseHoldIncome.workingIncome = workingIncome;
    },
    setHowManyPeople(state, howManyPeople) {
      state.data.howManyPeople = howManyPeople;
    },
  },
  getters: {
    getStep: state => () => state.step,
    getIsBusy: state => () => state.isBusy,
    getData: state => () => state.data,
    getBodyData: state => () => {
      return {
        AnnualIncome: state.data.houseHoldIncome.workingIncome,
        MonthlyIncome: state.data.houseHoldIncome.monthlyChecks,
        Dependents: state.data.howManyPeople,
        ZipCode: "75001"
      }
    },
    getQueryParams: state => () => {
      let params = {};
      if (process.env.TOKEN) params.Token = process.env.TOKEN;
      if (state.data.hasMedicaid) {
        params.lisHasMedicaid = true;
      } else {
        params.lisHasMedicaid = false;
        params.lisSavingsAboveThreshold = Boolean(state.data.moreThan14390);
        params.lisAnnualIncome = parseFloat(state.data.houseHoldIncome.workingIncome);
        params.lisMonthlyCheckIncome = parseFloat(state.data.houseHoldIncome.monthlyChecks);
        params.lisDependents = parseInt(state.data.howManyPeople);
      }

      params = {...params, ...state.queryString }
      
      return params;
    },
    getScore: state => () => state.score,
  },
  actions: {
    calculate({state, getters}) {
      state.isBusy = true;
      const data = getters.getBodyData();
      return axios.post(ENDPOINT_URL, data)
        .then((response = {}) => {
          const Data = (response.data) ? response.data.Data : null;
          state.isBusy = false;
          state.score = Data || 0;
          return Promise.resolve(response);
        });
    },
  },
  modules: {
  }
})
